module.exports = __webpack_public_path__ + "img/20191021163311360截图20191021153629768.afb1b5e4.jpg";